<style scoped>
table tr td {
  text-align: left !important;
}
table {
  text-align: left !important;
}
</style>
<template>
  <CCard>
    <CCardHeader
      style="background:#1a3665;color:white"
      class="d-flex align-items-center font-weight-bold"
    >
      Asean CPA
      <div class="col-lg-5 col-sm-12 d-flex align-items-center ml-auto">     
      </div>
    </CCardHeader>
    <CCardBody>
      <CRow class="mb-3">
        <div class="col-sm-12 col-xl-12">          
          <div class="form-group">
            <label for class="font-weight-bold">Pilih Kategori Anggota</label>
            <multiselect
              class="mulit-select"
              label="namaKategori"
              placeholder="Pilih kategori"
              :show-labels="false"
              @select="filterByKategori"
              v-model="kategori"
              required
              id="namaKategori"
              :options="dataKategoriAnggota"
            ></multiselect>            
          </div>
          <div class="text-right">
            <button class="btn btn-md btn-info mr-2" @click="resetFilter">Reset Filter</button>
            <button class="btn btn-md btn-success" @click="filterData">Terapkan</button>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id @change="changePageSize">
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option value="Semua Data">Semua Data</option>
            </select>
          </div>
        </div>        
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."              
              v-model="search"
            />
          </div>
        </div>    
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht:100% !important; text-align: left;"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{index}">
              <td class="py-2">{{index+1}}</td>
            </template>
            <template #no_anggota="{item}">
              <td class="py-2 font-weight-bold">{{item.no_anggota ? item.no_anggota : "-"}}</td>
            </template>
            <template #nama_lengkap="{item}">
              <td class="py-2">{{item.nama_lengkap ? item.nama_lengkap : "-"}}</td>
            </template>
            <template #nama_kategori="{item}">
              <td class="py-2">{{item.nama_kategori ? item.nama_kategori : "-"}}</td>
            </template>
            <template #email="{item}">
              <td class="py-2">{{item.email ? item.email : "-"}}</td>
            </template>
            <template #alamat_ktp="{item}">
              <td class="py-2">{{item.alamat_ktp ? item.alamat_ktp : "-"}}</td>
            </template>
            <template #statusPersyaratan="{item}">
              <td class="py-2">
                <button
                  class="btn btn-sm btn-success"
                  v-if="item.statusPersyaratan   == 1"
                >Terverifikasi</button>
                <button class="btn btn-sm btn-danger" v-else>Belum Terverifikasi</button>
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                  <CButton :disabled="item.status_dokumen == 0" color="info" square size="sm" @click="updateData(item, index)"  v-c-tooltip="'Ubah'">
                    <font-awesome-icon icon="edit" />
                  </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_read">
                  <router-link
                    :to="'/keanggotaan/asean-cpa/pengajuan-rekomendasi/'+item.id_asean_cpa"
                    class="mx-1"
                  >
                    <CButton color="warning" square size="sm" class="text-white"  v-c-tooltip="'Lihat Dokumen'">
                      <font-awesome-icon icon="file" />
                    </CButton>
                  </router-link>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                  <CButton color="danger" square size="sm" @click="deleteData(item, index)"  v-c-tooltip="'Hapus'">
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body mt-n2">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="nomor_agt" class="font-weight-bold">Nomor Anggota IAPI</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nomor_agt"
                      placeholder="Terisi Otomatis"
                      readonly
                      v-model="formData.no_anggota"
                    />
                    <input type="hidden" v-model="formData.id_asean_cpa" />                  
                  </div>
                  <input type="hidden" v-model="formData.id_user" />
                  <div class="form-group col-md-12">
                    <label
                      for="nama_lengkap_agt font-weight-bold"
                      class="font-weight-bold"
                    >Nama Lengkap Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nama_lengkap_agt"
                      placeholder="Terisi Otomatis"
                      readonly
                      v-model="formData.nama_lengkap"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="kategori_agt" class="font-weight-bold">Kategori Anggota</label>
                  <input
                    type="text"
                    class="form-control"
                    id="kategori_agt"
                    placeholder="Terisi Otomatis"
                    readonly
                    v-model="formData.nama_kategori"
                  />
                </div>
                <div class="form-group">
                  <label for="email_agt" class="font-weight-bold">Email Anggota</label>
                  <input
                    type="text"
                    class="form-control"
                    id="email_agt"
                    placeholder="Terisi Otomatis"
                    readonly
                    v-model="formData.email"
                  />
                </div>
                <div class="form-group">
                  <label for="alamat" class="font-weight-bold">Alamat</label>
                  <textarea
                    type="text"
                    class="form-control"
                    id="alamat"
                    placeholder="Terisi Otomatis"
                    readonly
                    v-model="formData.alamat_ktp"
                  />
                </div>
                <div class="form-group">
                  <label for="email_agt" class="font-weight-bold">Nomor Sertifikat</label>
                  <input
                    type="text"
                    class="form-control"    
                    v-model="formData.no_sertifikat"
                  />
                </div>
                <div class="form-group">
                  <label for class="font-weight-bold">Status</label>
                  <br />
                  <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        :value="'1'"
                        v-model="formData.statusPersyaratan"
                        id="aktif"
                      />
                      <label class="custom-control-label" for="aktif">Terverifikasi</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        :value="'0'"
                        id="tidak_aktif"
                        v-model="formData.statusPersyaratan"
                      />
                      <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                    </div>
                  </div>
                </div>
              <div class="form-group" v-show="formData.statusPersyaratan != '1'">
                <label for class="font-weight-bold">Alasan <span>(Opsional)</span></label>
                <textarea 
                  class="form-control" 
                  name="" 
                  id="" 
                  cols="30" 
                  rows="4" 
                  v-model="formData.alasan" 
                  placeholder="Masukkan alasan">
                </textarea>
              </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import AseanCpaService from "../../services/keanggotaan/asean-cpa.service";
import DataKeanggotaanService from "../../services/keanggotaan/data-anggota.service";
import KategoriAnggotaService from "../../services/keanggotaan/kategori-anggota.service";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: true
  },
  {
    key: "no_anggota",
    label: "No. Anggota",
    sorter: true,
    filter: true,
    _style: "font-weight: bold"
  },
  {
    key: "nama_lengkap",
    label: "Nama Anggota",
    sorter: true,
    filter: true
  },
  {
    key: "nama_kategori",
    label: "Kategori Anggota",
    sorter: true,
    filter: true
  },
  {
    key: "email",
    label: "Email Anggota",
    sorter: true,
    filter: true
  },
  {
    key: "alamat_ktp",
    label: "Alamat Anggota",
    sorter: true,
    filter: true,
    _style: "width:25%;"
  },
  {
    key: "statusPersyaratan",
    _style: " text-align: center",
    sorter: true,
    filter: true
  },
  {
    key: "aksi",
    _style: "width:12.2%; text-align: center",
    sorter: true,
    filter: true
  }
];

export default {
  data() {
    return {
      items: [],
      actionPost: "",
      dataUser: [],
      search: "",
      pageSize: 10,
      dataKategoriAnggota: {},
      kategori: {},
      multi_user: [
        {
          id_user: null,
          email: "",
          nama_lengkap: null,
          nama_kategori: "",
          alamat: "",
          no_anggota: ""
        }
      ],
      formData: {
        status: "",
        id_asean_cpa: "",
        id_user: "",
        email: "",
        nama_lengkap: "",
        nama_kategori: "",
        alamat: "",
        no_anggota: "",
        namaKategori: "",
        statusPersyaratan: "",
        alasan: "",
        no_sertifikat : '',
      },
      pagination: {
        totalPages: 0
      },
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      myModalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      indexed: 0,
      title: "",
      role_status : null
    };
  },
  mounted() {
    this.roleData();
    this.getDataAnggota();
    this.getDataKategoriAnggota();
    this.getData("0", this.pageSize, "default", this.kategori.namaKategori);
  },
  watch: {
    multi_user: function(val) {
      this.formData.idUser = val.id_user;
    },
    currentPage: function(val) {
      //alert val -1
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search, this.kategori.namaKategori);
    },
    search: function() {
      setTimeout(() => {
        this.getData("0", this.pageSize, this.search, this.kategori.namaKategori);
      }, 1000);
    }
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
      },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search, this.kategori.namaKategori);
    },

    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search, this.kategori.namaKategori);
    },

    filterByKategori(value) {      
      this.kategori = value;      
    },

    filterData() {
      this.getData("0", this.pageSize, "default", this.kategori.namaKategori)
    },

    resetFilter() {
      this.kategori = {};
      this.items = [];
    },

    cariData() {
      this.getData("0", this.pageSize, this.search, this.kategori.namaKategori);
    },

    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },

    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },

    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            AseanCpaService.deleteAseanCpa(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertSuccess();
                this.getData("0", this.pageSize, this.search, this.kategori.namaKategori);
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
            Toast.fire({
              icon: "cancel",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter, kategori) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      AseanCpaService.getAseanCpa(currentPage, pageSize, filter, kategori)
        .then(response => {
          loader.hide();
          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    getDataAnggota() {
      var vm = this;
      DataKeanggotaanService.getAllDataAnggota()
        .then(response => {
          vm.dataUser = response.data.data;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getDataKategoriAnggota() {
      var vm = this;
      KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
          vm.dataKategoriAnggota = response.data.data.content;          
          this.kategori = this.dataKategoriAnggota[0];
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    createData() {
      this.myModal = true;

      this.formData = {};

      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {
      if (this.actionPost == "insert") {
        this.insertData(this.formData);
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      AseanCpaService.postAseanCpa(formData)
        .then(response => {
          this.myModal = false;
          this.alertSuccess();
          this.getData("0", this.pageSize, "default", this.kategori.namaKategori);
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError();
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });                  
      AseanCpaService.putAseanCpa(this.formData)
        .then(response => {
          loader.hide();
          // comment console console.log("ini edit data");
          this.myModal = false;
          this.alertSuccess();
          this.getData("0", this.pageSize, "default", this.kategori.namaKategori);
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError();
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>